import * as React from 'react'
import SummaryPrice from '../../common/components/summary-price'
import QuoteNumber from '../../common/components/quote-number'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import { Table, Row, Cell } from '../../common/components/summary-table'
import { toCurrency } from '../../common/util'
import { withConfig } from  '../../common/modules/config'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withStatus } from '../../common/modules/status'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withState } from '../../common/modules/state'
import { withScrollToTop } from '../../common/modules/scroll-to-top'


export const formConfig = state => {
    return {
        rules: {
            propertyExcess: [],
            waterDamageExcess: []
        },
        predicates:{},
        options:{},
        inferred:{},
        transformOut: data => data,
    }
}


@withSubmission
@withNavigation
@withProductData
@withValidation
@withRouteBlocker
@withFields
@withScrollToTop
@withStatus
@withForm(formConfig)
export default class extends React.Component<any, any> {

    
    componentWillMount(){
        const path = window.location.href;        
        if(this.props.fields.referred){
            const newPath = path+'?status=Referred'
            window.location.replace(newPath);
        }
        else if(this.props.fields.showPrice){
            const newPath = path + '?status=Quoted'
            window.location.replace(newPath);
        }
        else if(this.props.fields.indicativePrice){
            const newPath = path + '?status=IndicativePrice'
            window.location.replace(newPath);
        }

        
        if(this.props.fields.declined || this.props.fields.referred){
            this.props.actions.navigation.setCloseWarning(false);
            this.props.actions.navigation.disableRoutes([
                "/step-1",
                "/step-2",
                "/step-3",
                "/step-4",
                "/step-5"
            ])
        }

        if(this.props.fields.declined){
            this.props.actions.navigation.changeRoute("/declined");
        }
    }


    updateExcess(field, value){
        console.log("Changed excess: " + field)
        console.log(value);

        if (field === "propertyExcess" && value != null && parseInt(value) === 300 && this.props.fields.ownersCorporationAddress.state !== "SA") {
            this.props.actions.status.showMessage(null, "The selected excess is not available for the nominated state. Please select a valid excess.", false);
            return;
        }

        this.props.actions.fields.updateField(field, value);

        const endpoint = this.props.submission.endpoints.flatQuote;
        this.props.actions.submission.submit(
            endpoint,
            this.setStateAfterPostSuccess.bind(this),
            [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig,
            require("./step-4").formConfig,
            require("./step-5").formConfig,
            require("./step-6").formConfig,
            require("./step-8").formConfig,
            ],
            false,
            this.setStateAfterPostFailure.bind(this)
        );
    }
    
    setStateAfterPostSuccess() {
        this.setState({
            "errorMessage": undefined
        });
    }
    setStateAfterPostFailure(err) {
        this.setState({
            "errorMessage": err
        });
    }
    render() {
        const fields = this.props.fields;
        const productData = this.props.productData;
        const lossOfRentAmount = fields.buildingSumInsured * (fields.lossOfRentPercent/100)
        const workersCompDecommissionDate = new Date("2023-10-01");
        const startDateArray = fields.startDate.split('/'); // startDate = "yyyy/mm/dd";
        const inceptionDate = new Date(startDateArray[2], startDateArray[1]-1, startDateArray[0] );
        const disableWorkersComp = (inceptionDate >= workersCompDecommissionDate);

        return (
            <div className="row">
                <StepTitle>Here's The Cover You Requested</StepTitle>
                <QuoteNumber />

                <SubHeader>Your Protection Overview</SubHeader>

                <Table>

                    <Row highlight>
                        <Cell>Section 1 - Insured Property</Cell><Cell></Cell>
                    </Row>

                    <Row>
                        <Cell>Building</Cell><Cell>${ toCurrency(fields.buildingSumInsured) }</Cell>
                    </Row>

                    <Row>
                        <Cell>Contents</Cell><Cell>${ toCurrency(fields.contentsSumInsured) }</Cell>
                    </Row>

                    <Row>
                        { disableWorkersComp &&
                            <Cell>Lot owners' fixtures and improvements (per lot)</Cell>
                        }
                        { !disableWorkersComp &&
                            <Cell>Lot owners' fixtures and improvements (per lot)</Cell>
                        }
                        <Cell>${ toCurrency(fields.lotOwnersSumInsured) }</Cell>
                    </Row>

                    <Row highlight>
                        <Cell>Optional Extensions</Cell><Cell></Cell>
                    </Row>

                    <Row>
                        { disableWorkersComp &&
                            <Cell>Catastrophe insurance</Cell>
                        }
                        { !disableWorkersComp &&
                            <Cell>Catastrophe insurance</Cell>
                        }
                        <Cell>{ !fields.catastropheRequired && "Not insured" }</Cell>
                    </Row>

                    { fields.catastropheRequired &&
                        <Row>
                            <Cell>Catastrophe Sum Insured</Cell><Cell>${ toCurrency(fields.catastropheSumInsured) }</Cell>
                        </Row>
                    }

                    { fields.catastropheRequired &&
                        <Row>
                            <Cell>Extended cover - Rent/Temporary Accommodation</Cell><Cell>${toCurrency( fields.catastropheExtendedCoverRentTemporaryAccomodation) }</Cell>
                        </Row>
                    }

                    { fields.catastropheRequired &&
                        <Row>
                            <Cell>Escalation in Cost of Temp Accommodation</Cell><Cell>${ toCurrency(fields.catastropheEscalationTemporaryAccomodation) }</Cell>
                        </Row>
                    }

                    { fields.catastropheRequired &&
                        <Row>
                            <Cell>Cost or Removal, Storage and Evacuation</Cell><Cell>${ toCurrency(fields.catastropheStorageEvacuation) }</Cell>
                        </Row>
                    }

                    <Row>
                        { disableWorkersComp &&
                            <Cell>Machinery breakdown </Cell>
                        }
                        { !disableWorkersComp &&
                            <Cell>Machinery breakdown </Cell>
                        }
                        <Cell>{ fields.machineryBreakdownRequired ? "$" + toCurrency(fields.machineryBreakdownSumInsured) : "Not insured" }</Cell>
                    </Row>


                    { fields.machineryBreakdownRequired &&
                        <Row>
                            <Cell>Machinery breakdown excess</Cell><Cell>${ toCurrency(fields.machineryBreakdownExcess) }</Cell>
                        </Row>
                    }

                    { fields.machineryBreakdownRequired &&
                        <Row>
                            <Cell>Machinery Breakdown chiller excess</Cell><Cell>{ fields.chillersOrCoolingTowers ? "$" + toCurrency(fields.machineryBreakdownChillerExcess) : "Not insured" }</Cell>
                        </Row>
                    }

                    <Row>
                        <Cell>Lot Owners' Contents</Cell>
                        <Cell>{fields.lotOwnerContentsRequired ? "$" + fields.lotOwnerContentsSumInsured + " (per residential lot)" : "Not insured"}</Cell>
                    </Row>

                    <Row>
                        <Cell>Loss of Rent/Temporary Accommodation (total payable)</Cell><Cell>${ toCurrency(lossOfRentAmount) }</Cell>
                    </Row>

                    { (fields.ownersCorporationAddress.state == "NSW" || fields.ownersCorporationAddress.state == "ACT") &&
                    <Row>
                        <Cell>Optional Lot/Unit Wall Coverings</Cell><Cell>{ fields.paintBenefit ? "Selected" : "Not insured" }</Cell>
                    </Row>
                    }

                    <Row>
                        <Cell>Property excess</Cell>
                        <Cell>
                            { !fields.referred &&
                            <select id="propertyExcess" className="form-control"
                                value={ fields.propertyExcess }
                                onChange={e => this.updateExcess("propertyExcess", e.target.value) }>
                                { productData.excesses.Property.BUILDING.map(item => <option value={ parseInt(item.value) }>{ "$" + toCurrency(item.value) }</option>) }
                            </select>
                            }
                            { fields.referred &&
                                <span>${ toCurrency(fields.propertyExcess) }</span>
                            }
                        </Cell>
                    </Row>

                    <Row>
                        <Cell help="This Excess will apply to Section 1 – Insured Property if the loss or damage is caused by Water Damage as defined in the PDS.">Water damage excess</Cell>
                        <Cell>
                            { !fields.referred &&
                            <select id="waterDamageExcess" className="form-control"
                                value={ fields.waterDamageExcess }
                                onChange={e => this.updateExcess("waterDamageExcess", e.target.value) }>
                                { productData.excesses.Property.WATER.map(item => <option value={ parseInt(item.value) }>{ "$" + toCurrency(item.value) }</option>) }
                            </select>
                            }
                            { fields.referred &&
                                <span>${ toCurrency(fields.waterDamageExcess) }</span>
                            }
                        </Cell>
                    </Row>

                    <Row highlight>
                        <Cell>Section 2 - Liability to others</Cell><Cell></Cell>
                    </Row>

                    <Row>
                        <Cell>Sum insured</Cell><Cell>${ toCurrency(fields.liabilitySumInsured) }</Cell>
                    </Row>

                    <Row highlight>
                        <Cell>Section 3 - Voluntary Workers</Cell><Cell>{ fields.voluntaryWorkersRequired ? "Selected" : "Not insured" }</Cell>
                    </Row>

                    { fields.voluntaryWorkersRequired &&
                    <Row>
                        <Cell>Death</Cell><Cell>{ "$" + toCurrency(fields.voluntaryWorkersDeath) }</Cell>
                    </Row>
                    }

                    { fields.voluntaryWorkersRequired &&
                    <Row>
                        <Cell>Total Disablement</Cell><Cell>{ "$" + toCurrency(fields.voluntaryWorkersDisablementWeekly) }</Cell>
                    </Row>
                    }

                    { !disableWorkersComp &&
                        <Row highlight>
                            <Cell>Section 4 - Workers
                                Compensation</Cell><Cell>{fields.workersCompensationRequired ? "Selected" : "Not insured"}</Cell>
                        </Row>
                    }

                    <Row highlight>
                        { disableWorkersComp &&
                            <Cell>Section 4 - Fidelity Guarantee and Cyber </Cell>
                        }
                        { !disableWorkersComp &&
                            <Cell>Section 5 - Fidelity Guarantee and Cyber </Cell>
                        }
                        <Cell></Cell>
                    </Row>

                    { fields.fidelityRequired &&
                    <Row>
                        <Cell>Fidelity Guarantee Sum Insured </Cell>
                        <Cell>{ "$" + toCurrency(fields.fidelitySumInsured) }</Cell>
                    </Row>
                    }

                    { fields.fidelityRequired &&
                    <Row>
                        <Cell>Cyber Sum Insured </Cell>
                        <Cell>{ "$" + toCurrency(fields.cyberSumInsured) }</Cell>
                    </Row>
                    }

                    <Row highlight>
                        { disableWorkersComp &&
                            <Cell>Section 5 - Office bearers legal liability </Cell>
                        }
                        { !disableWorkersComp &&
                            <Cell>Section 6 - Office bearers legal liability </Cell>
                        }
                        <Cell>{ fields.officeBearersRequired ? "$" + toCurrency(fields.officeBearersSumInsured) : "Not insured" }</Cell>
                    </Row>

                    <Row highlight>
                        { disableWorkersComp &&
                            <Cell>Section 6 - Government Audit Costs and Legal Expenses</Cell>
                        }
                        { !disableWorkersComp &&
                            <Cell>Section 7 - Government Audit Costs and Legal Expenses</Cell>
                        }
                        <Cell></Cell>
                    </Row>

                    <Row>
                        <Cell>Government Audit Costs</Cell><Cell>${ toCurrency(fields.gaGovernmentAuditSumInsured) }</Cell>
                    </Row>

                    <Row>
                        <Cell>Appeal expenses - common property health &amp; safety breaches</Cell><Cell>${ toCurrency(fields.gaAppealExpensesSumInsured) }</Cell>
                    </Row>

                    <Row>
                        <Cell>Legal Defence Expenses</Cell><Cell>${ toCurrency(fields.gaLegalDefenceExpensesSumInsured) }</Cell>
                    </Row>
                </Table>
            
                <SummaryPrice 
                    referred = { fields.referred }
                    totalPayable = { fields.totalPayable }
                    basePremium = { fields.basePremium }
                    levies = { fields.levies }
                    gst = { fields.gst }
                    stampDuty = { fields.stampDuty }
                    adminFee = { fields.adminFee }
                    brokerFee = { fields.brokerFee }
                    commission = { fields.commission }
                    commissionGst = { fields.commissionGst }
                    summaryText = { fields.summaryText }
                    actions = { this.props.actions }
                    indicativePrice = {fields.indicativePrice}
                    indicativePriceText = {fields.indicativePriceText}
                />

                <Button.Container show={ fields.referred == false} >
                    <Button.Back route={('A' !== this.props.fields.strataWindZone) ? "/step-8" : "/step-5"} /> <Button.Save onClick={ this.save.bind(this) }/> <Button.BuyNow onClick={ this.onContinue.bind(this)} />
                </Button.Container>
            </div>
        )
    }

    save(){
        this.props.actions.submission.save("/step-6", [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig,
            require("./step-4").formConfig,
            require("./step-5").formConfig,
            require("./step-6").formConfig,
        ]);
    }


    onContinue(){
            if (!this.state || !this.state.errorMessage) {
                this.props.actions.navigation.changeRoute("/step-7");
            }
            else {
                this.props.actions.status.showMessage(null, this.state.errorMessage, false);
            }
    }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/strata/routes/step-6.tsx